<div
  class="continue-editing-root"
  [ngStyle]="cssVars"
  [style.width]="'var(--continue-editing-dialog-width, fit-content)'"
  [style.border-radius]="'var(--continue-editing-dialog-radius, 4px)'"
>
  <div mat-dialog-title class="continue-editing-title">
    <div class="header">
      <span
        class="title continue-editing-title__text"
        [style.color]="'var(--continue-editing-title-color, var(--ep-texts-primary-text, #191919))'"
        [style.text-align]="'var(--continue-editing-title-align, left)'"
        [style.font-family]="'var(--continue-editing-title-font-family, var(--ep-font-family))'"
        [style.font-size]="'var(--continue-editing-title-font-size, var(--ep-font-size-popup-header, 19px))'"
        [style.font-style]="'var(--continue-editing-title-font-style, normal)'"
        [style.font-weight]="'var(--continue-editing-title-font-weight, var(--ep-font-weight-bold))'"
        [style.line-height]="'var(--continue-editing-title-line-height, 143.75%)'"
      >
        {{ data.title }}
      </span>

      <div class="close-button">
        <a (click)="close('primary')"><app-svg-icon class="x-icon" src="./assets/icons/close-icon.svg"></app-svg-icon></a>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div mat-dialog-content class="continue-editing-content">
    <p class="continue-editing-description">
      <span
        class="continue-editing-description__text"
        [style.color]="'var(--continue-editing-desc-color, var(--ep-texts-primary-text, #191919))'"
        [style.text-align]="'var(--continue-editing-desc-align, left)'"
        [style.font-family]="'var(--continue-editing-desc-font-family, var(--ep-font-family))'"
        [style.font-size]="'var(--continue-editing-desc-font-size, var(--ep-font-size-body, 16px))'"
        [style.font-style]="'var(--continue-editing-desc-font-style, normal)'"
        [style.font-weight]="'var(--continue-editing-desc-font-weight, var(--ep-font-weight-regular))'"
        [style.line-height]="'var(--continue-editing-desc-line-height, 143.75%)'"
        [innerHtml]="data.description"
      >
      </span>
    </p>
  </div>

  <div mat-dialog-actions class="continue-editing-actions gap-8 button-container">
    <button
      *ngFor="let btn of data.buttons"
      mat-button
      [ngClass]="{
        'ep-btn': true,
        'ep-btn-primary': btn.role === 'primary',
        'ep-btn-secondary': btn.role === 'secondary',
        'ep-btn-tertiary': btn.role === 'tertiary'
      }"
      (click)="close(btn.role)"
    >
      {{ btn.text }}
    </button>
  </div>
</div>
